import { __ } from '@wordpress/i18n';
import AreaRenderer from '../areas/AreaRenderer';
import './CardEditor.css';

const CardEditor = ({ 
  sections, 
  onOpenModal, 
  onEditField, 
  onDeleteField,
  onMoveFieldUp,
  onMoveFieldDown
}) => {
  return (
    <div className="hvnly--builder---api_property__builder__left-panel">
      <h2 className="hvnly--builder---api_property__builder__section-title">{__('Property Card Builder', 'havenlytics')}</h2>
      <div className="hvnly--builder---api_property__builder__card__container">
        <div className="hvnly--builder---api_property__builder___preview_section">
          <div className="hvnly--builder---api_property__builder___single_page_card">
            <div className="hvnly--builder---api_property__builder___single_page_card_header">
              
              {/* Thumbnail Area - No background image in editor */}
              <AreaRenderer 
                area="thumbnail"
                sections={sections}
                onOpenModal={onOpenModal}
                onEditField={onEditField}
                onDeleteField={onDeleteField}
                onMoveFieldUp={onMoveFieldUp}
                onMoveFieldDown={onMoveFieldDown}
              />
              
              {/* Corner Areas */}
              <div className="hvnly--builder---api_property__builder___single_page_card_corner hvnly--builder---api_property__builder___single_page_card_top_left">
                <AreaRenderer 
                  area="top-left"
                  sections={sections}
                  onOpenModal={onOpenModal}
                  onEditField={onEditField}
                  onDeleteField={onDeleteField}
                  onMoveFieldUp={onMoveFieldUp}
                  onMoveFieldDown={onMoveFieldDown}
                />
              </div>
              
              <div className="hvnly--builder---api_property__builder___single_page_card_corner hvnly--builder---api_property__builder___single_page_card_top_right">
                <AreaRenderer 
                  area="top-right"
                  sections={sections}
                  onOpenModal={onOpenModal}
                  onEditField={onEditField}
                  onDeleteField={onDeleteField}
                  onMoveFieldUp={onMoveFieldUp}
                  onMoveFieldDown={onMoveFieldDown}
                />
              </div>
              
              <div className="hvnly--builder---api_property__builder___single_page_card_corner hvnly--builder---api_property__builder___single_page_card_bottom_left">
                <AreaRenderer 
                  area="bottom-left"
                  sections={sections}
                  onOpenModal={onOpenModal}
                  onEditField={onEditField}
                  onDeleteField={onDeleteField}
                  onMoveFieldUp={onMoveFieldUp}
                  onMoveFieldDown={onMoveFieldDown}
                />
              </div>
              
              <div className="hvnly--builder---api_property__builder___single_page_card_corner hvnly--builder---api_property__builder___single_page_card_bottom_right">
                <AreaRenderer 
                  area="bottom-right"
                  sections={sections}
                  onOpenModal={onOpenModal}
                  onEditField={onEditField}
                  onDeleteField={onDeleteField}
                  onMoveFieldUp={onMoveFieldUp}
                  onMoveFieldDown={onMoveFieldDown}
                />
              </div>
            </div>
            
            {/* Rest of your existing CardEditor code remains exactly the same */}
            <div className="hvnly--builder---api_property__builder___single_page_card_body">
              {/* Combined Avatar and Title Area - FLEX LAYOUT */}
              <div className="hvnly--builder---api_property__builder___avatar_title_container">
                {/* Avatar Area - Left Side */}
                <AreaRenderer 
                  area="avatar"
                  sections={sections}
                  onOpenModal={onOpenModal}
                  onEditField={onEditField}
                  onDeleteField={onDeleteField}
                  onMoveFieldUp={onMoveFieldUp}
                  onMoveFieldDown={onMoveFieldDown}
                />
                
                {/* Title Area - Right Side */}
                <AreaRenderer 
                  area="title"
                  sections={sections}
                  onOpenModal={onOpenModal}
                  onEditField={onEditField}
                  onDeleteField={onDeleteField}
                  onMoveFieldUp={onMoveFieldUp}
                  onMoveFieldDown={onMoveFieldDown}
                />
              </div>
              
              {/* Content Areas */}
              {['excerpt', 'features','content'].map(area => (
                <AreaRenderer 
                  key={area}
                  area={area}
                  sections={sections}
                  onOpenModal={onOpenModal}
                  onEditField={onEditField}
                  onDeleteField={onDeleteField}
                  onMoveFieldUp={onMoveFieldUp}
                  onMoveFieldDown={onMoveFieldDown}
                />
              ))}
            </div>
            
            {/* Footer Area */}
            <div className="hvnly--builder---api_property__builder___single_page_card_footer">
              <div className="hvnly--builder---api_property__builder___single_page_card_footer_left">
                <AreaRenderer 
                  area="footer-left"
                  sections={sections}
                  onOpenModal={onOpenModal}
                  onEditField={onEditField}
                  onDeleteField={onDeleteField}
                  onMoveFieldUp={onMoveFieldUp}
                  onMoveFieldDown={onMoveFieldDown}
                />
              </div>
              <div className="hvnly--builder---api_property__builder___single_page_card_footer_right">
                <AreaRenderer 
                  area="footer-right"
                  sections={sections}
                  onOpenModal={onOpenModal}
                  onEditField={onEditField}
                  onDeleteField={onDeleteField}
                  onMoveFieldUp={onMoveFieldUp}
                  onMoveFieldDown={onMoveFieldDown}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardEditor;